import axios from "axios";
import request from "../utils/request";
import { data } from "autoprefixer";

// 页面视图
export function GetMyInfo() {
    return request({
        url: "/Api/2025/0331/Load.ashx"
    });
}

// 收货地址提交
export function SubmitAddress(name, cardid, phone, address) {
    return request({
        method: "post",
        url: "/Api/2025/0331/Submit.ashx",
        data: {
            name,
            cardid,
            phone,
            address
        }
    });
}

// 获取地址列表
export function GetAreas() {
    return new Promise((resolve) => {
        axios
            .get("https://static.web.sdo.com/chuanshi/common/ares.json")
            .then((res) => {
                resolve(res.data);
            });
    });
}
